<div class="container-fluid page">
  <div class="d-flex align-items-center mb-3" style="gap: 20px">
    <span class="go-back" [routerLink]="'/settings/velocity-limit/list'">
      <img src="assets/images/arrow-left.svg" alt="arrow-left" />Velocity Limit
    </span>
    <img src="assets/images/arrow-right.svg" alt="arrow-right" />
    <ng-container *ngIf="!isEdit">Add</ng-container>
    <ng-container *ngIf="isEdit">Edit</ng-container>
    Velocity Limit
  </div>
  <form
    class="mat-form"
    [formGroup]="upsertVelocityForm"
    (ngSubmit)="onSubmit()">
    <div class="row mt-2">
      <div class="col-12">
        <mat-card>
          <div class="row">
            <div class="col-md-6 form-group">
              <app-input-select
                (selectionChange)="onSourceCountryChange($event)"
                [inputData]="attrConstant.srcCountry"
                [selectOptions]="sourceCountryList | async"
                [bindLabel]="'countryName'"
                [bindValue]="'countryCode'"
                [formControlName]="
                  attrConstant.srcCountry.key
                "></app-input-select>
            </div>
            <div class="col-md-6 form-group">
              <app-input-select
                (selectionChange)="onDestCountryChange($event)"
                [inputData]="attrConstant.destCountry"
                [selectOptions]="destCountryList | async"
                [bindLabel]="'countryName'"
                [bindValue]="'countryCode'"
                [formControlName]="
                  attrConstant.destCountry.key
                "></app-input-select>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.sourceCurrency"
                [formControlName]="
                  attrConstant.sourceCurrency.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.destinationCurrency"
                [formControlName]="
                  attrConstant.destinationCurrency.key
                "></app-input-template>
            </div>
            <ng-container
              *ngIf="
                upsertVelocityForm.value.src_country !== '' &&
                upsertVelocityForm.value.dest_country !== ''
              ">
              <div
                class="col-md-6 form-group"
                *ngFor="let data of transferTypeList">
                <mat-form-field appearance="outline">
                  <mat-label>{{ data.name }} Velocity Limit</mat-label>
                  <input
                    matInput
                    type="number"
                    [formControlName]="
                      data.value.replace('-', '_') | lowercase
                    " />
                </mat-form-field>
              </div>
            </ng-container>
          </div>
        </mat-card>
      </div>
    </div>
    <button class="btn primary-btn w-100 mt-3">Submit</button>
  </form>
</div>
